<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="title"
      [canGoBack]="!deletingKey"
      [noBow]="deletingKey"
      [customBack]="'more/developers'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">

    <tidy-wrapper>


      @if (loaded) {
        @if (!deletingKey) {
          <tidy-card>
            @if (!loadFailed && apiKeys?.length !== 0) {
              <tidy-two-column-row>
                <tidy-text
                  [body]="'Viewing live API keys'" />
                <tidy-text
                  [actionBody]="'View Documentation'"
                  (action)="goToApiDocumentation()"
                  class="link" />
              </tidy-two-column-row>
              @for (key of apiKeys; track key) {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [header]="'Token'" />
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      [body]="key?.token" />
                  </tidy-row>
                  <tidy-text
                    [header]="'Environment'" />
                  <tidy-row [alignLastItemRight]="true">
                    <tidy-text
                      [body]="'Production'" />
                    <tidy-text
                      [body]="'Delete Key'"
                      (action)="deleteApiKey(key?.id)"
                      class="link" />
                  </tidy-row>
                </tidy-row>
              }
            }
            @if (loadFailed || apiKeys?.length === 0) {
              <tidy-row [align]="'center'" class="extra-bottom-padding">
                @if (loadFailed) {
                  <tidy-text
                    [body]="'Contact your account manager to get set up with the TIDY API or Zapier.'" />
                } @else {
                  <tidy-text
                    [body]="'You have no API keys. Contact your account manager to get set up with the TIDY API or Zapier.'" />
                }
              </tidy-row>
              <tidy-button
                [text]="'Create New API Key'"
                [action]="boundRequestApiAccess"
                class="primary" />
            }
          </tidy-card>
        }
        @if (deletingKey) {
          <tidy-card>
            <tidy-text
              [body]="'You will be unable to perform any more actions with this key.'" />
            <tidy-checkbox
              formControlName="checkbox"
              [form]="form.controls.checkbox"
              [items]="[{viewValue: 'Yes I want to delete this key.', value: true}]" />
          </tidy-card>
          <tidy-error-message
            [text]="errorMessage" />
          <tidy-two-column-row>
            <tidy-button
              [text]="'Go Back'"
              [action]="boundStopDeletingApiKey"
              class="secondary" />
            <tidy-button
              [text]="'Delete Key'"
              [action]="boundConfirmDeleteApiKey"
              class="primary" />
          </tidy-two-column-row>
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ng-container *ngTemplateOutlet="content" />
}
